<template>
<div class="container-fluid">
	<materials-tasks-toolbar title="Labour Tasks">

		<search-bar placeholder="Search labour actions..." 
			v-on:submit="search">		
		</search-bar>

	</materials-tasks-toolbar>

	<categorized-list-module
		record-name="Task"
		category-api-resource="LabourActionCategory"
		record-api-resource="LabourAction"
		num-records-field="num_actions"
		:list-fields="fields"
		:import-columns="importColumns"
		:import-column-labels="importColumnLabels"
		:import-example-rows="importExampleRows"
		:payload-initial-values="payloadInitialValues"
		:fetch-trigger-toggle="fetchTriggerToggle"
		:searchable-fields="['description']"
		:search-terms="searchTerms"
		v-on:editRecord="editAction"
		v-on:newRecord="newAction"
		v-on:categoryChange="categoryChange">
	</categorized-list-module>

	<modal-dialog :modal-visible="editModal.visible"
		:title="editModal.title"
		confirm-button-text="Save"
		v-on:closeModal="editModal.visible = false"
		v-on:confirm="saveLabourAction">

		<field label="Category" 
			col-class="col-sm-4" 
			:params="{type: 'static'}" 
			:value="categoryName">	
		</field>

		<field label="Description" 
			col-class="col-sm-4" 
			v-model="editModal.payload.description">
		</field>

		<field label="Unit Type" 
			col-class="col-sm-4" 
			:params="{type:'select',options:['Each','Metre','Ft','Sq. Ft.','Sq. Metre']}" 
			v-model="editModal.payload.unit_type">
		</field>

		<field label="Labour Hrs" 
			col-class="col-sm-4" 
			:params="{type:'number',min:0,step:0.001,placeholder:'0.00'}" 
			v-model="editModal.payload.labour_hrs">
		</field>

		<template slot="footer">
			<button class="btn btn-outline-danger" type="button" v-on:click="deleteLabourAction">
				<i class="fa fa-trash"></i>
				Delete
			</button>
		</template>

	</modal-dialog>

	<modal-dialog :modal-visible="deleteConfirmModalVisible"
		title="Delete Labour Action"
		confirm-button-text="Yes, Delete"
		button-class="btn-outline-danger"
		v-on:closeModal="deleteConfirmModalVisible"
		v-on:confirm="confirmDelete">

		Are you sure you want to delete this Labour Action?

	</modal-dialog>
</div>
</template>

<script type="text/javascript">
import MaterialsTasksToolbar from "@/pages/materials/MaterialsTasksToolbar"

import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Widget from "@/components/Widget"

import SearchBar from "@/components/SearchBar"
import Field from "@/components/Field"

import CategorizedListModule from "@/components/super_components/CategorizedListModule"

import ContextMenu from "@/layout_fragments/ContextMenu"
import Toolbar from "@/layout_fragments/Toolbar"

export default {
	components: {
		MaterialsTasksToolbar,
		TableList,
		ModalDialog,
		Widget,
		Field,
		SearchBar,
		ContextMenu,
		CategorizedListModule,
		Toolbar
	},
	data() {
		return {
			searchTerms: "",
			fields: [
				{label: "Description",key:"description"},
				{label: "Category", key: "parentCategoryName"},
				{label: "Labour (hrs/unit)",key:'labour_hrs',align:'right'},
				{label: "Unit Type", key: "unit_type"}
			],
			importColumns: ["description","labour_hrs","unit_type"],
			importColumnLabels: ["Description","Labour Hrs","Unit Type"],
			importExampleRows: [
				["A","B","C","D","E","F"],
				['1/2" EMT Conduit','EMT-123','2018-01-02','100','89.93','0.750'],
				['EMT Elbow','EMT 90 ELL','2018-01-02','100','45.22','0.250'],
				['1/2" Conduit Body','CBLB50COM','2018-01-02','1','5.76','0.470'],
			],
			payloadInitialValues: {
				description: "",
				labour_hrs: 1,
				unit_type: "each"
			},
			editModal: {
				visible: false,
				title: "",
				payload: {}
			},
			fetchTriggerToggle: false,
			selectedCategory: null,
			deleteConfirmModalVisible: false
		}
	},
	computed: {
		categoryName() {
			if (this.selectedCategory)
				return this.selectedCategory.name

			return ""
		}
	},
	methods: {
		search(terms) {
			this.searchTerms = terms
		},
		newAction() {
			this.editModal.visible = true
			this.editModal.payload = {
				category_id: this.selectedCategory.id,
				description: "",
				unit_type: "Each",
				labour_hrs: 0
			}
			this.editModal.title = "New Labour Action"
		},
		editAction(record) {
			this.editModal.visible = true
			this.editModal.payload = this.cloneObj(record)
			this.editModal.title = "Edit Labour Action"
		},
		categoryChange(cat) {
			this.selectedCategory = cat
		},
		saveLabourAction() {
			let vm = this

			this.postData("LabourAction/save",this.editModal.payload).then(response => {
				if (response.success) {
					vm.alertSaved("Labour Action saved")
					vm.editModal.visible = false
					vm.fetchTriggerToggle = !vm.fetchTriggerToggle
				}
			})
		},
		deleteLabourAction() {
			this.deleteConfirmModalVisible = true
		},
		confirmDelete() {
			let vm = this

			this.postData("LabourAction/delete",{id: this.editModal.payload.id},true).then(response => {
				if (response.success) {
					vm.deleteConfirmModalVisible = false
					vm.alertSuccess("Labour Action Deleted")
					vm.editModal.visible = false
					vm.fetchTriggerToggle = !vm.fetchTriggerToggle
				}
			})
		}
	}

}
</script>
